<form [formGroup]="huurToeslagFg">
    <div formArrayName="huurwoningen">
        <div *ngFor="let item of woningen.controls; let i = index" [formGroupName]="i">
            <div class="row mb-0.5">
                <div class="col-auto">
                    <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                    [label]="i === 0 ? 'Postcode' : ''"
                                                    class="custom-input-100"
                                                    formControlName="postcode"
                                                    id="postcode"
                    >
                    </snelstart-ui-text-form-control>
                </div>
                <div class="col-auto">
                    <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                    [label]="i === 0 ? 'Huisnummer' : ''"
                                                    class="custom-input-75"
                                                    formControlName="huisnummer"
                                                    id="huisnummer"
                    >
                    </snelstart-ui-text-form-control>
                </div>
                <div class="col-auto">
                    <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                    [label]="i === 0 ? 'Toev.' : ''"
                                                    class="custom-input-60"
                                                    formControlName="huisnummerToevoeging"
                                                    id="huisnummerToevoeging"
                    >
                    </snelstart-ui-text-form-control>
                </div>
                <div class="col-auto">
                    <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                    [label]="i === 0 ? 'Woonplaats' : ''"
                                                    class="custom-input-150"
                                                    formControlName="woonplaats"
                                                    id="woonplaats"
                    >
                    </snelstart-ui-text-form-control>
                </div>
                <div class="col-auto">
                    <div formGroupName="bewoondePeriode">
                        <snelstart-ui-date-form-control (change)="this.saveForm()"
                                                        [label]="i === 0 ? 'Bewoond van' : ''"
                                                        class="custom-input-125"
                                                        formControlName="begindatum"
                                                        id="begindatum"
                                                        placeholder="dd-mm-{{this.year}}"
                        >
                        </snelstart-ui-date-form-control>
                    </div>
                </div>
                <div class="col-auto">
                    <div formGroupName="bewoondePeriode">
                        <snelstart-ui-date-form-control (change)="this.saveForm()"
                                                        [label]="i === 0 ? 'Bewoond t/m' : ''"
                                                        class="custom-input-125"
                                                        formControlName="einddatum"
                                                        id="einddatum"
                                                        placeholder="dd-mm-{{this.year}}"
                        >
                        </snelstart-ui-date-form-control>
                    </div>
                </div>
                <div class="col-auto">
                    <snelstart-ui-button (click)="this.showDialog(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         icon="plus"
                                         type="secondary">Huurgegevens
                    </snelstart-ui-button>
                </div>
                <div class="col-auto">
                    <snelstart-ui-button (click)="this.showDialogMedebewoner(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         icon="plus"
                                         type="secondary">Medebewoners
                    </snelstart-ui-button>
                </div>
                <div class="col-auto">
                    <snelstart-ui-button (click)="verwijderRij(i)"
                                         [class]="i === 0 ? 'firstrowbutton' : ''"
                                         icon="trash"
                                         iconType="light"
                                         id="buttonDelete"
                                         size="medium"
                                         type="secondary"
                    >
                    </snelstart-ui-button>
                </div>
            </div>
        </div>
    </div>
</form>

<div *ngIf="woningen.length === 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelA"
                         type="link">Gegevens woning invullen
    </snelstart-ui-button>
</div>
<div *ngIf="woningen.length !== 0">
    <snelstart-ui-button (click)="addRij()" class="snelstart-ui-button pb-3" icon="plus" id="cancelB"
                         type="link">Woning toevoegen
    </snelstart-ui-button>
</div>

<snelstart-ui-dialog-definition (close)="dialogVisible=false" [(visible)]="dialogVisible" id="huurwoningGegevens"
                                size="lg" title="Gegevens huurprijs en kosten (t/m 2025) van de huurwoning">
    <snelstart-ui-dialog-body>
        <form [formGroup]="huurToeslagFg">
            <div formArrayName="huurwoningen">
                <div *ngFor="let item of woningen.controls; let i = index" [formGroupName]="i">
                    <div *ngIf="i === this.index">
                        <div>
                            <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                              [showAllDecimals]="false"
                                                              align="right"
                                                              class="custom-input-250"
                                                              formControlName="kaleHuurprijsPerMaand"
                                                              id="kaleHuurprijsPerMaand"
                                                              label="Kale huurprijs per maand"
                                                              prefix="€"
                            >
                            </snelstart-ui-number-form-control>
                        </div>

                        @if (this.allowanceEntity.year != undefined && this.allowanceEntity.year < 2026) {
                            <div class="space20"></div>
                            <p><b>Servicekosten per maand</b></p>

                            <div>
                                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                                  [showAllDecimals]="false"
                                                                  align="right"
                                                                  class="custom-input-250"
                                                                  formControlName="energiekostenPerMaand"
                                                                  id="energiekostenPerMaand"
                                                                  label="Energiekosten gemeensch. ruimten "
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                                  [showAllDecimals]="false"
                                                                  align="right"
                                                                  class="custom-input-250"
                                                                  formControlName="schoonmaakkostenPerMaand"
                                                                  id="schoonmaakkostenPerMaand"
                                                                  label="Schoonmaakkosten gemeensch. ruimten "
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div>

                                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                                  [showAllDecimals]="false"
                                                                  align="right"
                                                                  class="custom-input-250"
                                                                  formControlName="huismeersterkostenPerMaand"
                                                                  id="huismeersterkostenPerMaand"
                                                                  label="Huismeesterkosten"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                            <div>
                                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                                  [showAllDecimals]="false"
                                                                  align="right"
                                                                  class="custom-input-250"
                                                                  formControlName="algemeneservicePerMaand"
                                                                  id="algemeneservicePerMaand"
                                                                  label="Kosten dienst- en recreatieruimten "
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button btn-x class="me-1" id="cancelE" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button (click)="!this.dialogVisible" icon="check" id="save" type="primary">Akkoord
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<snelstart-ui-dialog-definition (close)="dialogMedebewonerVisible=false" [(visible)]="dialogMedebewonerVisible"
                                id="medebewonersGegevens" size="xl" title="Gegevens medebewoners">
    <snelstart-ui-dialog-header-content>
        Vul de gegevens van de medebewoner(s) in en kies de periode dat de betreffende medebewoner op hetzelfde
        adres als de aanvrager ingeschreven stond in {{ this.year }}.

        @if (heeftToeslagPartner) {
            <br/>Let op! Een (toeslag)partner hoef je niet in te vullen als medebewoner!
        }

    </snelstart-ui-dialog-header-content>
    <snelstart-ui-dialog-body>
        <form [formGroup]="huurToeslagFg">
            <div formArrayName="huurwoningen">
                <div *ngFor="let item of woningen.controls; let i = index" [formGroupName]="i">
                    <div *ngIf="i === this.index">
                        <div formArrayName="medebewoners">
                            <div *ngFor="let medebewoner of getMedebewoners(i).controls; let j = index"
                                 [formGroupName]="j" class="row">
                                <snelstart-ui-text-form-control (change)="this.saveForm()"
                                                                [label]="j === 0 ? 'Naam medebewoner' : ''"
                                                                class="custom-input-200"
                                                                formControlName="naam"
                                                                id="naam"
                                >
                                </snelstart-ui-text-form-control>

                                <snelstart-ui-date-form-control (change)="this.saveForm()"
                                                                [label]="j === 0 ? 'Geboortedatum' : ''"
                                                                class="custom-input-150"
                                                                formControlName="geboortedatum"
                                                                id="geboortedatum"
                                >
                                </snelstart-ui-date-form-control>

                                <snelstart-ui-bsn-form-control (change)="this.saveForm()"
                                                               [label]="j === 0 ? 'Bsn' : ''"
                                                               class="custom-input-150"
                                                               formControlName="bsn"
                                                               id="bsn"
                                >
                                </snelstart-ui-bsn-form-control>

                                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                                  [label]="j === 0 ? 'Toetsinkomen ' : ''"
                                                                  [showAllDecimals]="false"
                                                                  align="right" class="custom-input-125"
                                                                  formControlName="inkomen"
                                                                  id="inkomen"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>


                                <snelstart-ui-number-form-control (change)="this.saveForm()"
                                                                  [label]="j === 0 ? 'Toetsvermogen ' : ''"
                                                                  [showAllDecimals]="false"
                                                                  align="right" class="custom-input-125"
                                                                  formControlName="toetsvermogen"
                                                                  id="toetsvermogen"
                                                                  prefix="€"
                                >
                                </snelstart-ui-number-form-control>


                                <ng-container formGroupName="periodeSamenwonend">

                                    <snelstart-ui-date-form-control (change)="this.saveForm()"
                                                                    [label]="j === 0 ? 'Begindatum' : ''"
                                                                    class="custom-input-150"
                                                                    formControlName="begindatum"
                                                                    id="begindatumSamenwonen"
                                                                    placeholder="dd-mm-{{this.year}}"
                                    >
                                    </snelstart-ui-date-form-control>


                                    <snelstart-ui-date-form-control (change)="this.saveForm()"
                                                                    [label]="j === 0 ? 'Einddatum' : ''"
                                                                    class="custom-input-150"
                                                                    formControlName="einddatum"
                                                                    id="einddatumSamenwonen"
                                                                    placeholder="dd-mm-{{this.year}}"
                                    >
                                    </snelstart-ui-date-form-control>
                                </ng-container>
                                <snelstart-ui-button (click)="verwijderRij(i)"
                                                     [class]="j === 0 ? 'firstrowbutton col-auto' : ' col-auto'"
                                                     icon="trash"
                                                     iconType="light"
                                                     id="buttonDelete"
                                                     size="medium"
                                                     type="secondary"
                                >
                                </snelstart-ui-button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="getMedebewoners(this.index).length === 0">
                        <snelstart-ui-button (click)="addMedebewoner(this.index)"
                                             class="snelstart-ui-button pb-3" icon="plus"
                                             id="cancelC"
                                             type="link">Medebewoner invullen
                        </snelstart-ui-button>
                    </div>
                    <div *ngIf="getMedebewoners(this.index).length !== 0">
                        <snelstart-ui-button (click)="addMedebewoner(this.index)"
                                             class="snelstart-ui-button pb-3" icon="plus"
                                             id="cancelD"
                                             type="link">Medebewoner toevoegen
                        </snelstart-ui-button>
                    </div>
                </div>
            </div>
        </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button btn-x class="me-1" id="cancelF" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button (click)="!this.dialogMedebewonerVisible" icon="check" id="save1" type="primary">Akkoord
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
